/** Stable machine codes — safe for logs, audits, and API details. */
export const ERROR_CODES = {
  // Validation (domain rules — userMessageKey often equals legacy error_* keys)
  VALIDATION: 'validation.failed',

  // Auth
  AUTH_REQUIRED: 'auth.required',
  AUTH_INVALID_CREDENTIALS: 'auth.invalid_credentials',
  AUTH_SESSION_EXPIRED: 'auth.session_expired',
  AUTH_MFA_REQUIRED: 'auth.mfa_required',
  AUTH_MFA_UNSUPPORTED: 'auth.mfa_unsupported',
  AUTH_ACCOUNT_EXISTS: 'auth.account_exists',

  // Access
  PERMISSION_DENIED: 'permission.denied',
  NOT_FOUND: 'not_found',
  CONFLICT: 'conflict',

  // Connectivity
  OFFLINE: 'offline.no_connection',
  SERVER_UNREACHABLE: 'offline.server_unreachable',
  NETWORK_UNAVAILABLE: 'network.unavailable',

  // Limits & config
  RATE_LIMIT: 'rate_limit.exceeded',
  CONFIG_SAVE_FAILED: 'config.save_failed',
  CONFIG_INVALID: 'config.invalid',

  // External
  EXTERNAL_SERVICE: 'external.service_down',

  // Fallback
  INTERNAL: 'internal.unexpected',
} as const;

export type ErrorCode = typeof ERROR_CODES[keyof typeof ERROR_CODES];

/** i18n keys for user-visible copy (plain language, all ages). */
export const USER_MESSAGE_KEYS = {
  GENERIC: 'err_generic',
  GENERIC_HINT: 'err_generic_hint',
  OFFLINE: 'err_offline',
  OFFLINE_HINT: 'err_offline_hint',
  SERVER_UNREACHABLE: 'err_server_unreachable',
  SERVER_UNREACHABLE_HINT: 'err_server_unreachable_hint',
  PERMISSION_DENIED: 'err_permission_denied',
  PERMISSION_DENIED_HINT: 'err_permission_denied_hint',
  AUTH_REQUIRED: 'err_auth_required',
  AUTH_REQUIRED_HINT: 'err_auth_required_hint',
  MFA_REQUIRES_RECENT_LOGIN: 'mfaRequiresRecentLogin',
  MFA_TOTP_EMULATOR_UNAVAILABLE: 'mfaTotpEmulatorUnavailable',
  NOT_FOUND: 'err_not_found',
  CONFLICT: 'err_conflict',
  RATE_LIMIT: 'err_rate_limit',
  EXTERNAL_SERVICE: 'err_external_service',
  CONFIG_SAVE_FAILED: 'err_config_save_failed',
  CONFIG_SAVE_FAILED_HINT: 'err_config_save_failed_hint',
  PLAY_FAILED: 'err_play_failed',
  PLAY_FAILED_HINT: 'err_play_failed_hint',
} as const;
